export default __webpack_public_path__ + "img/trial-balance-icon.482687b9.svg";